<template>
  <div>
    <spinner-component v-show="show_spinner"></spinner-component>
    <left-navbar class="index-left" />
    <div class="index-right">
      <div class="nav-header">
        <div class="right-title">
          <span>MAX'Bx</span><small v-show="is_dev">&ensp;-&ensp;工程版</small>
          <!-- ( {{ windowWidth }} / {{ windowHeight }}) -->
        </div>
        <div class="set-date">
          <i class="fa-solid fa-calendar-days"></i>
          <flat-pickr v-model="set_date" :config="flatPickrConfig" placeholder="Select date"></flat-pickr>
        </div>
      </div>
      <div class="nav-header">
        <div class="switch-region">
          <div class="region-item" v-for="region, index in user_regions" :key="index"
            :class="{ 'active': selected_region.id === region.id }" @click="regionSwitch(region.id)">
            {{ region.name }}
          </div>
        </div>
        <div class="switch-data-type">
          <div v-show="picked_function === 'power-overview'">
            <a href="#" :class="{ 'selected': data_type === 'barChart' }" @click="switchDataType('barChart')">即時資料</a> |
            <a href="#" :class="{ 'selected': data_type === 'lineChart' }" @click="switchDataType('lineChart')">歷史資料</a>
          </div>
        </div>
        <div class="btn-group switch-billing-mode" v-show="picked_function === 'bill-query'">
          <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown">
            電力監測系統 {{ translateBillMode(bill_mode) }}
          </button>
          <div class="dropdown-menu dropdown-menu-right p-4 text-muted">
            <h4>電力監控系統 電費計算</h4><small>(更新時間：103/05/27)</small>
            <div class="dropdown-divider"></div>
            <button class="dropdown-item" type="button" v-for="value, index in bill_mode_list" :key="index"
              @click="switchBillMode(value.name)">
              {{ translateBillMode(value.name) }} <small>({{ value.explain }})</small>
            </button>
          </div>
        </div>
      </div>
      <power-overview v-if="picked_function === 'power-overview'" />
      <bill-query v-if="request_date && picked_function === 'bill-query'" />
    </div>
  </div>
</template>

<script>
import DataExport from './buttons/DataExport.vue';
import SelectCircuits from './buttons/SelectCircuits.vue';
import PowerOverview from './PowerOverview.vue';
import BillQuery from './BillQuery.vue';
import { axiosMixins } from './mixins/axiosErrorMessage';
import SpinnerComponent from './layouts/SpinnerComponent.vue';
import UserSetting from './modal/UserSetting.vue';
import LeftNavbar from './layouts/LeftNavbar.vue';
// date input plugin
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/light.css';

export default {
  components: {
    DataExport,
    SelectCircuits,
    PowerOverview,
    BillQuery,
    SpinnerComponent,
    flatPickr,
    UserSetting,
    LeftNavbar
  },
  mixins: [axiosMixins],
  data() {
    return {
      base_url: base_url,
      region_name: "",
      set_date: '',
      bill_mode_list: [
        { name: "residential", explain: "適用一般住家" },
        { name: "nonResidential", explain: "適用機關、學校等非營業性質的機構" },
        { name: "commercial", explain: "適用小型營業場所、商店、辦公室等營業性質的機構" }
      ],
      bill_mode: '',
      spinner_timer: null,
    };
  },
  async mounted() {
    console.log('--ex-home-- mounted');
    this.$store.commit('setShowSpinner', true);
    await this.$store.dispatch('setUserRegions');
    // 預設為區域中第一個電表
    const default_meter = this.$store.getters.selectedRegion.meters[0];
    await this.$store.dispatch('setRequestDate', default_meter.bx_mac);
    console.log('--ex-home-- end set request date')
    await this.$store.dispatch('setSelectedMeter', default_meter.id);
  },
  computed: {
    is_dev() {
      if (process.env.NODE_ENV === 'production') {
        document.title = "MAX'Bx";
        return false;
      } else {
        document.title = "MAX'Bx - development";
        return true;
      }
    },
    show_spinner() {
      return this.$store.getters.showSpinner;
    },
    user_regions() {
      return this.$store.getters.userRegions;
    },
    selected_region() {
      return this.$store.getters.selectedRegion;
    },
    request_date() {
      this.set_date = this.$store.getters.requestDate;
      return this.$store.getters.requestDate;
    },
    data_type() {
      return this.$store.getters.dataType;
    },
    picked_function() {
      return this.$store.getters.pickedFunction;
    },
    flatPickrConfig() {
      return {
        ...this.$store.getters.flatPickrConfig,
        disableMobile: true,
        onChange: (selectedDates, dateStr, instance) => {
          console.log('--ex-home-- flatpickr onChange');
          if (this.request_date !== dateStr) {
            this.$store.commit("setRequestDate", dateStr);
            this.$store.dispatch('setSelectedMeter');
          }
        }
      };
    },
    billMode() {
      return this.$store.getters.billMode;
    },
    windowHeight() {
      return window.innerHeight;
    },
    windowWidth() {
      return window.innerWidth;
    }
  },
  watch: {
    billMode() {
      console.log('--ex-home-- billMode changed');
      this.bill_mode = this.billMode;
    },
    show_spinner() {
      if (this.spinner_timer) {
        clearInterval(this.spinner_timer);
        this.spinner_timer = null;
      }
      // refresh page every 30 sec if still spinning
      if (this.show_spinner) {
        this.spinner_timer = setInterval(() => {
          window.location.reload();
        }, 15000);
      }
    },
    deep: true,
  },
  methods: {
    switchDataType(type) {
      console.log('--ex-home-- data type switch');
      this.$store.commit('setHistoricalDataTimeFormat', 'day');
      this.$store.commit('setDataType', type);
    },
    async regionSwitch(region_id) {
      console.log('--ex-home-- region switch');
      if (this.selected_region.id !== region_id) {
        this.$store.commit('setSelectedRegion', region_id);
        await this.$store.dispatch('setRequestDate', this.$store.getters.selectedRegion.meters[0].bx_mac);
        // 預設為區域中第一個電表
        console.log('--ex-home-- end set request date after region switch');
        await this.$store.dispatch('setSelectedMeter', this.$store.getters.selectedRegion.meters[0].id);
      }
    },
    translateBillMode(bill_mode) {
      switch (bill_mode) {
        case "nonResidential":
          return "非營業用電";
        case "commercial":
          return "營業用電";
        default:
          return "住宅用電";
      }
    },
    switchBillMode(bill_mode) {
      if (this.billMode !== bill_mode) {
        console.log('--ex-home-- call switchBillMode api');
        axios.patch(base_url + "/api/regions/bill-mode/" + this.selected_region.id, {
          "bill_mode": bill_mode
        }).then((response) => {
          this.$store.dispatch('setUserRegions');
        }).catch(error => this.axiosMessage(error));
      }
    },
  }
};
</script>

<style>
.set-date .form-control:disabled,
.set-date .form-control[readonly],
.set-date .form-control:focus {
  background-color: transparent;
  opacity: 1;
  box-shadow: none;
  cursor: pointer;
}

.set-date .form-control {
  color: var(--bx-blur);
  border: none;
}

.flatpickr-months .flatpickr-month,
.flatpickr-current-month .flatpickr-monthDropdown-months,
.flatpickr-weekdays,
span.flatpickr-weekday {
  background: var(--bx-body-background);
}

.dayContainer .flatpickr-day.selected,
.dayContainer .flatpickr-day:hover {
  color: #fff;
  background: var(--bx-dark-blue);
  border-color: var(--bx-dark-blue);
}
</style>

<style scoped>
a {
  text-decoration: none;
}

.index-left {
  padding: 0 calc(20% * 0.08) 0 calc(20% * 0.08);
  width: 15%;
  float: left;
  height: 100vh;
  background-color: var(--bx-dark-blue);
  text-align: center;
  display: flex;
  flex-direction: column;
  color: var(--bx-blur);
}

.index-right {
  height: 100vh;
  width: 85%;
  float: right;
  color: var(--bx-blur);
}

.index-right a {
  color: var(--bx-blur);
}

.index-right .nav-header {
  display: flex;
  align-items: center;
  height: 7vh;
  justify-content: space-between;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  border-bottom: 2px solid rgba(0, 0, 0, 0.05);
}

.index-right .nav-header .switch-data-type .selected {
  font-weight: bolder;
  color: var(--bx-dark-blue);
}

.index-right .nav-header .set-date {
  display: flex;
  align-items: center;
}

.index-right .nav-header .set-date svg {
  font-size: 1rem;
  margin-right: .8rem;
}

.index-right .nav-header .right-title {
  display: flex;
  align-items: center;
}

.index-right .nav-header .right-title>span {
  font-size: 1.5rem;
  color: var(--bx-dark-blue);
}

.index-right .nav-header .switch-region {
  height: 100%;
  display: flex;
  align-items: flex-end;
}

.index-right .nav-header .switch-region .region-item {
  padding: 0 .8rem 0 .8rem;
  cursor: pointer;
  height: 70%;
}

.index-right .nav-header .switch-region .active {
  border-bottom: 2px solid var(--bx-green);
  font-weight: bolder;
}

.index-right .nav-header .switch-billing-mode {
  font-size: .8rem;
  color: white;
}

@media (max-width: 1150px) {
  .index-left .function-bag>div {
    font-size: .8rem;
  }
}
</style>
